import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=228adf8f"
import script from "./configuration.vue?vue&type=script&lang=ts"
export * from "./configuration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports